(function () {
    var drawer = document.querySelector('[data-lame-drawer]');
    if (!drawer) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var itemsEl = drawer.querySelector('[data-lame-cart-items]');
    var subtotalEl = drawer.querySelector('[data-lame-cart-subtotal]');
    var checkoutBtn = drawer.querySelector('[data-lame-checkout]');
    var errorEl = drawer.querySelector('[data-lame-cart-error]');
    var lastFocus = null;

    function money(cents, currency) {
        try {
            return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) {
            return (cents / 100).toFixed(2) + ' ' + currency;
        }
    }

    function request(path, body) {
        var opts = { headers: { Accept: 'application/json' } };
        if (body) {
            opts.method = 'POST';
            opts.headers['Content-Type'] = 'application/json';
            opts.body = JSON.stringify(body);
        }
        return fetch(root + path, opts).then(function (res) {
            return res.json().then(function (data) {
                if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
                return data;
            });
        });
    }

    function el(tag, className, text) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        if (text != null) node.textContent = text;
        return node;
    }

    function render(cart) {
        document.querySelectorAll('[data-lame-cart-count]').forEach(function (node) {
            node.textContent = cart.item_count;
        });
        document.querySelectorAll('.lame-cartbtn').forEach(function (node) {
            node.hidden = cart.item_count === 0;
        });
        subtotalEl.textContent = money(cart.total_price, cart.currency);
        checkoutBtn.disabled = cart.item_count === 0;
        errorEl.hidden = true;

        itemsEl.replaceChildren();
        if (!cart.items.length) {
            itemsEl.appendChild(el('p', 'lame-drawer__empty', 'Your cart is empty.'));
            return;
        }
        cart.items.forEach(function (item, index) {
            var line = index + 1;
            var row = el('div', 'lame-item');

            var img = el('img');
            img.alt = '';
            if (item.image) img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
            row.appendChild(img);

            var info = el('div');
            info.appendChild(el('div', 'lame-item__title', item.product_title));
            if (item.variant_title) info.appendChild(el('div', 'lame-item__variant', item.variant_title));

            var qty = el('div', 'lame-item__qty');
            var minus = el('button', null, '−');
            minus.type = 'button';
            minus.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
            minus.dataset.lameLine = line;
            minus.dataset.lameQty = item.quantity - 1;
            var count = el('span', null, item.quantity);
            var plus = el('button', null, '+');
            plus.type = 'button';
            plus.setAttribute('aria-label', 'Increase quantity of ' + item.product_title);
            plus.dataset.lameLine = line;
            plus.dataset.lameQty = item.quantity + 1;
            qty.append(minus, count, plus);
            info.appendChild(qty);

            var remove = el('button', 'lame-item__remove', 'Remove');
            remove.type = 'button';
            remove.dataset.lameLine = line;
            remove.dataset.lameQty = 0;
            info.appendChild(remove);
            row.appendChild(info);

            row.appendChild(el('div', 'lame-item__price', money(item.final_line_price, cart.currency)));
            itemsEl.appendChild(row);
        });
    }

    function showError(message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
    }

    function open() {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        document.body.classList.add('lame-locked');
        drawer.querySelector('.lame-drawer__x').focus();
    }

    function close() {
        drawer.hidden = true;
        document.body.classList.remove('lame-locked');
        if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-lame-add-form]');
        if (!form) return;
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        var errorNode = form.querySelector('[data-lame-add-error]');
        var label = button.textContent;
        var id = new FormData(form).get('id');
        button.disabled = true;
        button.textContent = 'Adding…';
        if (errorNode) errorNode.hidden = true;
        request('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
            .then(function () { return request('cart.js'); })
            .then(function (cart) { render(cart); open(); })
            .catch(function (err) {
                if (errorNode) {
                    errorNode.textContent = err.message;
                    errorNode.hidden = false;
                }
            })
            .finally(function () {
                button.disabled = false;
                button.textContent = label;
            });
    });

    document.addEventListener('change', function (event) {
        var input = event.target.closest('[data-lame-format]');
        if (!input) return;
        var card = input.closest('[data-lame-product]');
        card.querySelector('[data-lame-price]').textContent = input.dataset.price;
        card.querySelector('[data-lame-price-label]').textContent = input.dataset.label;
    });

    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-lame-cart-open]')) {
            event.preventDefault();
            open();
            return;
        }
        if (event.target.closest('[data-lame-cart-close]')) {
            close();
            return;
        }
        var qtyBtn = event.target.closest('[data-lame-line]');
        if (qtyBtn) {
            request('cart/change.js', { line: Number(qtyBtn.dataset.lameLine), quantity: Number(qtyBtn.dataset.lameQty) })
                .then(render)
                .catch(function (err) { showError(err.message); });
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !drawer.hidden) close();
    });

    request('cart.js').then(function (cart) {
        render(cart);
        if (new URLSearchParams(window.location.search).get('cart') === 'open') open();
    });
})();
